
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music/category/[...categorySlug]",
      function () {
        return require("private-next-pages/music/category/[...categorySlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music/category/[...categorySlug]"])
      });
    }
  